module.exports = __webpack_public_path__ + "img/whole_box5_bg2.3673a12d.jpg";